import React from "react";
import HelpMatchImg from "../../images/helpmatch-img.png";
import { helpMatchItems } from "../../data/data";
import Button from "../button";
import { animateScroll as scroll } from "react-scroll";
import { handleEventAnalytics } from "../../utilities/eventAnalytics";
import ReactGA from "react-ga4";
import { trackCustomEvent } from "../../FacebookPixel";

const HelpMatchDifferent = ({ title, itemDetail }) => {
  const scrollToTop = () => {
    ReactGA.event(handleEventAnalytics("match_button_fold"));
    trackCustomEvent("Find My Match Button", {});
    const options = {
      duration: 0,
      smooth: true,
    };
    scroll.scrollToTop(options);
  };

  return (
    <section className="py-[50px] md:py-[100px]">
      <div className="container flex items-center lg:flex-row flex-col gap-[40px] xl:gap-[139px] ">
        <div className="col-left lg-max-w-[567px] max-w-[500] overflow-hidden text-[0] rounded-tl-[80px] rounded-tr-[80px] rounded-bl-[80px] rounded-br-[160px] xl:rounded-tl-[190px] xl:rounded-tr-[80px] xl:rounded-bl-[80px] xl:rounded-br-[300px]">
          <img src={HelpMatchImg} alt="" />
        </div>
        <div className="col-right lg:max-w-[573px] max-w-500">
          <h2 className="text-[26px] md:text-[36px] lg:text-[40px] text-center lg:text-left font-bold leading-[120%] mb-[14px] md:mb-[30px] text-customGray tracking[-0.8]">
            {title}
          </h2>
          <p className="para-2 text-lg font-normal leading-[160%] text-customGray mb-[27px] md:mb-[50px] text-center lg:text-left">
            {itemDetail}
          </p>
          <ul className="max-w-[445px] w-full">
            {helpMatchItems?.map((item, index) => (
              <li
                key={`${index}-list`}
                className="flex items-center gap-5 mb-[30px]"
              >
                <div
                  style={{ backgroundColor: `${item.bgColor}` }}
                  className="thumbnail w-[60px] h-[60px] rounded-[10px] flex items-center justify-center"
                >
                  <img src={item.img} alt="" />
                </div>
                <div className="detail w-[calc(100%-80px)]">
                  <p
                    className="text-base font-medium text-customGray leading-[160%]"
                    dangerouslySetInnerHTML={{ __html: item.detail }}
                  ></p>
                </div>
              </li>
            ))}
          </ul>
          <Button
            title="get matched now"
            classes="py-3 md:py-6 px-[100px] md:px-[40px] rounded-[10px] w-full md:w-auto bg-primary text-white text-base md:text-lg font-black duration-500 hover:bg-[#026ed6] capitalize"
            onClick={scrollToTop}
          />
        </div>
      </div>
    </section>
  );
};

export default HelpMatchDifferent;
